import React from 'react';
import i18n from 'i18next';

import {
  Button,
} from 'web-components';

import {
  Flex,
  Text,
  icons,
} from 'web-styled';

import Item from './Item';
import * as S from './styled';

type ItemType = {
  id: number,
  name: string,
};

type Props = {
  items?: Array<ItemType>,
  basePath?: string,
  resourceType?: string,
  onSelect?: { (): void },
  onRequestAdd: { (): void },
  onRequestDelete: { (): void },
  onChangeName: { (): void },
  onRemoveEntityTooltip: { (): void },
  openedTooltips: string[],
};

const EntityList = ({
  items,
  basePath,
  resourceType,
  onSelect,
  onChangeName,
  onRequestAdd,
  onRequestDelete,
  onRemoveEntityTooltip,
  openedTooltips,
}: Props) => (
  <Flex
    column
    fillSpace
    width="100%"
  >
    {items.length ? items.map(item => (
      <Item
        key={item.id}
        item={item}
        basePath={basePath}
        resourceType={resourceType}
        openedTooltips={openedTooltips}
        onSelect={onSelect}
        onChangeName={onChangeName}
        onRemoveEntityTooltip={onRemoveEntityTooltip}
      />
    )) : (
      <S.Empty>
        <img src={icons.folder} alt="" />
        <Text color="#ccc">
          You dont have
          <br />
          anything inside this folder.
        </Text>
        <Flex align="stretch" spacing={10} column>
          <Button
            ghost
            appearance="primary"
            icon="fa fa-plus"
            onClick={onRequestAdd}
          >
            {i18n.t(`add.${resourceType}`)}
          </Button>
          <Button
            ghost
            appearance="danger"
            onClick={onRequestDelete}
          >
            Delete Folder
          </Button>
        </Flex>
      </S.Empty>
    )}
  </Flex>
);

EntityList.defaultProps = {
  items: [],
  basePath: '/',
  resourceType: null,
  onSelect: () => {},
};

export default EntityList;
